export const getSlidesPerViewCount = (width, gap, preferredCardSize) => {
  const count = (width + gap) / (preferredCardSize + gap);

  if (count % 1 > 0.8) {
    return Math.round(count);
  }

  return Math.floor(count);
};
